module.exports = __webpack_public_path__ + "img/box1_icon2.6122672c.png";